import axios from "axios";
export const dataApi = axios.create({
  baseURL: "https://cookbook-d4d96.firebaseio.com/",
});
